import React from 'react';
import Logo from '../common/Logo';

const Footer = () => (
  <footer className="py-10 border-t" style={{ background: '#0a0a0a', borderColor: '#1a1a1a' }}>
    <div className="max-w-7xl mx-auto px-6 lg:px-8 flex flex-col md:flex-row justify-between items-center gap-4">
      <div className="flex items-center space-x-3">
        <Logo className="w-7 h-7 opacity-70" />
        <span className="text-sm font-semibold" style={{ color: '#f1f1f1' }}>Valtivo</span>
        <span style={{ color: '#2a2a2a' }}>|</span>
        <span className="text-xs uppercase tracking-wider" style={{ color: '#444' }}>Managed AI Call Handling</span>
      </div>
      <p className="text-xs" style={{ color: '#444' }}>&copy; 2026 Valtivo. All rights reserved.</p>
    </div>
  </footer>
);

export default Footer;